module.exports = __webpack_public_path__ + "static/media/kklogo-horz-play.8db17dea.png";